<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>New Payment</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label>Student</label>
          <vs-input autocomplete="off" readOnly name="Name" v-model="studentName" class="w-full" />
        </div>

        <div class="pt-4 pb-6" >
          <label>Amount</label>
          <vs-input onClick="this.select();" autocomplete="off" name="Amount" v-validate="{regex: '^[0-9]{1,6}([,.]{1}[0-9]{1,2})?$'}" v-model="amount" class="w-full" />
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addPayment" :disabled="isDisabled" ref="addButton" >Add</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedStudent: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      studentId: 0,
      amount: "",
      studentName: "",
      backgroundLoading:'#fff',
      isLoading: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    isDisabled: function(){
     return !this.amount;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        this.studentId = this.selectedStudent.id;
        this.amount = this.selectedStudent.amountOwed < 0 ? this.selectedStudent.amountOwed * -1 : this.selectedStudent.amountOwed;
        this.studentName = `${this.selectedStudent.userFirstName} ${this.selectedStudent.userLastName}`;
      }
    }
  },
  methods: {
    initValues() {
      this.studentId = 0;
      this.amount = "";
      this.studentName = "";
      this.errors.clear();
    },
    saveData(){
     this.$emit('saveData');
     this.$vs.loading.close(this.$refs.addButton.$el);
    },
    addPayment() {
      this.$validator.validate('Amount').then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          var onSuccess = response => {
            self.saveData();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Payment Added",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.addButton.$el);
          };

          self.$ajaxGet(self, "Transaction/Create?studentId=" + self.studentId + "&amount=" + self.amount, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addButton.$el,
        scale: 0.45
      });
    },
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
